import { UnitType } from '@exodus/currency'

const name = 'dogecoin'
const displayName = 'Dogecoin'
const ticker = 'DOGE'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#AAA27B'
const gradientColors = ['#AAA27B', '#978129']
const gradientCoords = { x1: '-43.8%', y1: '-41.579%', x2: '102%', y2: '101%' }
const chainBadgeColors = gradientColors

const units = {
  koinu: 0, // https://www.reddit.com/r/dogecoin/comments/2hkyq0/giveaway_1000000000_koinu_to_every_shibe/
  DOGE: 8,
}
const currency = UnitType.create(units)

const assetType = 'BITCOIN_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://blockchair.com/dogecoin/address/${address}`,
  txUrl: (txId) => `https://blockchair.com/dogecoin/transaction/${txId}`,
}
const info = {
  description:
    'Dogecoin is a decentralized, peer-to-peer digital currency that enables you to easily send money online.',
  reddit: 'https://www.reddit.com/r/dogecoin/',
  twitter: 'https://twitter.com/dogecoin',
  website: 'https://dogecoin.com/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
